(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-actions"] && !Shopify.designMode) return;
  try {
    // Wishlist panel-logik
  const WISHLIST_KEY = 'savior_wishlist';
  function getWishlist() { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); }

  function updateCount() {
    const count = getWishlist().length;
    const badge = document.getElementById('wishlist-count');
    if (!badge) return;
    badge.textContent = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
  }

  function renderWishlist() {
    const items = getWishlist();
    const container = document.getElementById('wishlist-items');
    if (!container) return;
    if (items.length === 0) {
      container.innerHTML = '<p style="color:#aaa;text-align:center;margin-top:40px;">Du har inga favoriter ännu.</p>';
      return;
    }
  container.innerHTML = items.map(p => {
  const variants = p.variants ? p.variants.split('|').map(v => {
    const [id, title] = v.split(':');
    return { id, title };
  }) : [];

  const sizeButtons = variants.map(v => `
    <button class="wl-size" data-product-id="${p.id}" data-variant-id="${v.id}"
      style="border:1px solid #ddd;background:white;padding:4px 10px;border-radius:4px;cursor:pointer;font-size:12px;">
      ${v.title}
    </button>
  `).join('');

  return `
    <div style="border-bottom:1px solid #eee;padding-bottom:16px;">
      <a href="${p.url}" style="display:flex;gap:12px;align-items:center;text-decoration:none;color:inherit;margin-bottom:10px;">
        <img src="${p.image}" style="width:70px;height:90px;object-fit:cover;border-radius:4px;">
        <div style="flex:1;">
          <div style="font-size:14px;font-weight:600;">${p.title}</div>
          <div style="font-size:13px;color:#666;margin-top:4px;">${p.price}</div>
        </div>
        <button class="wl-remove" data-id="${p.id}" style="background:none;border:none;cursor:pointer;font-size:16px;color:#aaa;align-self:flex-start;">✕</button>
      </a>
      <div style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:8px;">
        ${sizeButtons}
      </div>
      <button class="wl-cart" data-id="${p.variantId}"
        style="width:100%;background:black;color:white;border:none;padding:10px;border-radius:4px;cursor:pointer;font-size:13px;">
        Lägg i varukorg
      </button>
    </div>
  `;
}).join('');
container.querySelectorAll('.wl-size').forEach(btn => {
  btn.addEventListener('click', function() {
    const variantId = this.dataset.variantId;
    // Markera vald storlek
    const productId = this.dataset.productId;
    container.querySelectorAll(`.wl-size[data-product-id="${productId}"]`).forEach(b => {
      b.style.background = 'white';
      b.style.color = 'black';
    });
    this.style.background = 'black';
    this.style.color = 'white';
    // Uppdatera varukorgsknappen med rätt variant
    const cartBtn = this.closest('div[style*="border-bottom"]').querySelector('.wl-cart');
    if (cartBtn) cartBtn.dataset.id = variantId;
  });
});
container.querySelectorAll('.wl-cart').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const variantId = this.dataset.id;
      if (!variantId || variantId === 'undefined') {
        this.textContent = 'Välj storlek först!';
        this.style.background = '#999';
        setTimeout(() => {
          this.textContent = 'Lägg i varukorg';
          this.style.background = 'black';
        }, 2000);
        return;
      }
      this.textContent = 'Lägger till...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(res => res.json())
      .then(data => {
        if (data.id) {
          this.textContent = '✓ Tillagd!';
          setTimeout(() => location.href = '/checkout', 600);
        } else {
          this.textContent = 'Fel – försök igen';
          this.style.background = '#c00';
        }
      })
      .catch(() => {
        this.textContent = 'Fel – försök igen';
        this.style.background = '#c00';
      });
    });
  });

  }
  function closeWishlist() {
    const d = document.getElementById('wishlist-drawer');
    const o = document.getElementById('wishlist-overlay');
    if (d) d.style.right = '-420px';
    if (o) o.style.display = 'none';
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('#wishlist-toggle')) {
      document.getElementById('wishlist-drawer').style.right = '0';
      document.getElementById('wishlist-overlay').style.display = 'block';
      renderWishlist();
    }
    if (e.target.closest('#wishlist-close') || e.target.id === 'wishlist-overlay') {
      closeWishlist();
    }
  });

  updateCount();
  setInterval(updateCount, 500);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    const btn = e.target.closest('.hover-size');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;

    // Gör knappen visuellt aktiv
    btn.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    })
    .then(res => res.json())
    .then(data => {
      if (data.id) {
        window.location.href = '/checkout';
      }
    })
    .catch(err => {
      console.error('Fel vid tillägg:', err);
      btn.textContent = 'Fel!';
    });
  });
// ---- WISHLIST ----
  const WISHLIST_KEY = 'savior_wishlist';

  function getWishlist() {
    return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
  }
  function saveWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  }
  function updateHearts() {
    const ids = getWishlist().map(p => p.id);
    document.querySelectorAll('.wishlist-heart').forEach(btn => {
      btn.classList.toggle('active', ids.includes(parseInt(btn.dataset.productId)));
    });
  }

 document.addEventListener('click', function(e) {
    const btn = e.target.closest('.wishlist-heart');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

     const product = {
  id: parseInt(btn.dataset.productId),
  title: btn.dataset.productTitle,
  url: btn.dataset.productUrl,
  image: btn.dataset.productImage,
  price: btn.dataset.productPrice,
  variantId: btn.dataset.productVariant,
  variants: btn.dataset.productVariants
};

    let list = getWishlist();
    const exists = list.find(p => p.id === product.id);
    list = exists ? list.filter(p => p.id !== product.id) : [...list, product];
    saveWishlist(list);
    updateHearts();
  });

  updateHearts();
  } catch(e) { console.error(e); }
})();

})();
